import { useSearchParams } from "react-router-dom";
import SiteLayout from "@/components/layout/SiteLayout";
import Seo from "@/components/base/Seo";
import BusinessExplorer, {
  type DirectoryFilterState,
} from "@/components/feature/BusinessExplorer";
import ApiStatusBadge from "@/components/feature/ApiStatusBadge";
import type { BusinessSort } from "@/types/directory";

const VALID_SORTS: BusinessSort[] = ["relevance", "rating", "newest"];

export default function DirectoryPage() {
  const [searchParams] = useSearchParams();

  const sortParam = searchParams.get("sort") ?? "relevance";
  const initialFilters: Partial<DirectoryFilterState> = {
    keyword: searchParams.get("keyword") ?? "",
    category: searchParams.get("category") ?? "",
    district: searchParams.get("district") ?? "",
    location: searchParams.get("location") ?? "",
    sort: VALID_SORTS.includes(sortParam as BusinessSort)
      ? (sortParam as BusinessSort)
      : "relevance",
  };

  return (
    <SiteLayout>
      <Seo
        title="Browse Local Businesses in Coastal Karnataka"
        description="Search and filter verified businesses across South Canara, Udupi and North Canara by category, district and town. Compare ratings, hours and contact details and connect directly."
        keywords="browse businesses Karnataka, Mangaluru business search, Udupi directory, North Canara local businesses"
        path="/directory"
      />
      <section className="border-b border-background-200 bg-background-100">
        <div className="mx-auto w-full max-w-[1400px] px-6 py-10 md:py-12">
          <nav className="flex items-center gap-2 text-xs text-foreground-500" aria-label="Breadcrumb">
            <span>Home</span>
            <span className="flex h-3.5 w-3.5 items-center justify-center">
              <i className="ri-arrow-right-s-line text-sm" />
            </span>
            <span className="font-medium text-foreground-700">All Listings</span>
          </nav>
          <div className="mt-3 flex flex-wrap items-center gap-3">
            <h1 className="font-heading text-2xl font-extrabold text-foreground-950 md:text-4xl">
              Browse local businesses across coastal Karnataka
            </h1>
            <ApiStatusBadge />
          </div>
          <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
            Search by keyword and filter by category, district or town to find verified businesses in
            South Canara, Udupi and North Canara.
          </p>
        </div>
      </section>

      <section className="mx-auto w-full max-w-[1400px] px-6 py-10 md:py-12">
        <BusinessExplorer
          key={searchParams.toString()}
          initialFilters={initialFilters}
          pageSize={9}
          showPlacements
        />
      </section>
    </SiteLayout>
  );
}